import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const StrategyDiagram = () => {
  const steps = [
    {
      title: "Sourcing",
      description: "Proprietary deal flow through deep industry relationships and networks",
      icon: "1"
    },
    {
      title: "Due Diligence",
      description: "Comprehensive evaluation of manager track record, strategy, and economics",
      icon: "2"
    },
    {
      title: "Investment",
      description: "Acquisition of minority stake with focus on alignment and growth potential",
      icon: "3"
    },
    {
      title: "Value Creation",
      description: "Active partnership to help scale the platform and enhance operations",
      icon: "4"
    },
    {
      title: "Monitoring",
      description: "Ongoing performance tracking and strategic support",
      icon: "5"
    }
  ];

  return (
    <Box sx={{ mb: 8 }}>
      <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', mb: 4 }}>
        Our Process
      </Typography>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', md: 'row' },
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: '50%',
          left: 0,
          right: 0,
          height: '4px',
          backgroundColor: '#1976d2',
          display: { xs: 'none', md: 'block' },
          zIndex: 0
        }
      }}>
        {steps.map((step, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            viewport={{ once: true }}
            style={{ zIndex: 1 }}
          >
            <Box sx={{ 
              backgroundColor: 'white',
              border: '3px solid #1976d2',
              borderRadius: '50%',
              width: 60,
              height: 60,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 2,
              position: 'relative'
            }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                {step.icon}
              </Typography>
            </Box>
            <Box sx={{ 
              backgroundColor: 'white',
              p: 3,
              borderRadius: 2,
              boxShadow: 3,
              maxWidth: 220,
              textAlign: 'center'
            }}>
              <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
                {step.title}
              </Typography>
              <Typography variant="body2">
                {step.description}
              </Typography>
            </Box>
          </motion.div>
        ))}
      </Box>
    </Box>
  );
};

export default StrategyDiagram;
